import { Skeleton } from './Skeleton';

/**
 * Skeleton for a single menu item card
 */
export function MenuItemSkeleton() {
  return (
    <div className="relative flex h-[132px] bg-tg-secondary-bg rounded-xl overflow-hidden">
      {/* Content */}
      <div className="flex-1 min-w-0 p-3 space-y-2">
        {/* Title */}
        <Skeleton className="h-5 rounded w-3/4" />
        {/* Description */}
        <Skeleton className="h-3 rounded w-full" />
        <Skeleton className="h-3 rounded w-1/2" />
        {/* Price */}
        <Skeleton className="h-4 rounded w-1/4 mt-1" />
      </div>

      {/* Image skeleton (right side, full height) */}
      <Skeleton className="w-32 self-stretch flex-shrink-0" />

      {/* Add button skeleton */}
      <Skeleton className="w-8 h-8 rounded-full absolute bottom-2 right-2" />
    </div>
  );
}

/**
 * Skeleton for a category section with items
 */
export function CategorySectionSkeleton({ itemCount = 3 }: { itemCount?: number }) {
  return (
    <section className="scroll-mt-28">
      {/* Category title */}
      <Skeleton className="h-6 rounded w-32 mb-3" />

      {/* Menu items */}
      <div className="space-y-3">
        {Array.from({ length: itemCount }).map((_, i) => (
          <MenuItemSkeleton key={i} />
        ))}
      </div>
    </section>
  );
}

/**
 * Skeleton for the entire menu list
 */
export function MenuListSkeleton({ categoryCount = 3, itemsPerCategory = 3 }: { categoryCount?: number; itemsPerCategory?: number }) {
  return (
    <div className="px-4 py-4 space-y-6">
      {Array.from({ length: categoryCount }).map((_, i) => (
        <CategorySectionSkeleton key={i} itemCount={itemsPerCategory} />
      ))}
    </div>
  );
}

